import { jsx as t, Fragment as w, jsxs as l } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import $ from "./logo.webp.js";
import v from "./menu-dropdown-wrapper-mobile.svg.js";
import O from "./burger.svg.js";
import y from "./close.svg.js";
import { useState as N, useCallback as h, useMemo as A } from "react";
import { AccountLink as G } from "./account-link/index.js";
import x from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as C } from "./dropdown-menu-item/index.js";
import { useDisableScroll as R } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as S } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { getAboutLinks as H } from "./get-about-links.js";
import { MobileAccountModalLink as T } from "./mobile-account-modal/index.js";
import { ForLawyersMenuButtonMobile as q } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemMobile as I } from "./get-help-menu-item/index.js";
import { GradientButton as B } from "./gradient-button/index.js";
import { MenuChatButtonMobile as j } from "./chat-button/index.js";
import F from "./chevron-right-gradient.svg.js";
const ce = (a) => {
  const {
    isAuthenticated: c,
    openAuthModal: n,
    getTranslation: r,
    language: g,
    onRequestLawyer: o
  } = a, [u, m] = N(!1);
  R({ isDisabled: u });
  const p = h(() => {
    m(!0);
  }, []), s = h(() => {
    m(!1);
  }, []), i = h(() => {
    m(!1), c || n();
  }, [c, n]), d = h(() => {
    m(!1), a.logout();
  }, [a.logout]);
  return /* @__PURE__ */ t(w, { children: /* @__PURE__ */ l(
    "div",
    {
      className: `${e.menuModalOverlay} ${u ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ t(
          W,
          {
            isMenuOpen: u,
            closeMenu: s,
            openMenu: p,
            onAccountClick: i,
            handleLogout: d,
            isAuthenticated: a.isAuthenticated,
            userImage: a.userImage,
            hasNotifications: a.hasNotifications,
            language: g,
            getTranslation: r,
            isLawyerSupported: a.isLawyerSupported,
            onRequestLawyer: o
          }
        ),
        /* @__PURE__ */ t(
          K,
          {
            isAuthenticated: a.isAuthenticated,
            language: g,
            handleLogout: d,
            closeMenu: s,
            hasNotifications: a.hasNotifications,
            userImage: a.userImage,
            onAccountClick: i,
            getTranslation: r,
            isLawyerSupported: a.isLawyerSupported,
            onRequestLawyer: o
          }
        ),
        /* @__PURE__ */ t(v, { className: e.mobileBGIcon })
      ]
    }
  ) });
}, W = (a) => {
  const {
    isMenuOpen: c,
    closeMenu: n,
    openMenu: r,
    onAccountClick: g,
    handleLogout: o,
    isAuthenticated: u,
    hasNotifications: m,
    userImage: p,
    language: s,
    getTranslation: i,
    isLawyerSupported: d,
    onRequestLawyer: f
  } = a, [b, M] = N(!1), L = h(() => {
    M(!0);
  }, []), k = h(() => {
    M(!1);
  }, []);
  return /* @__PURE__ */ l("div", { className: e.mobileMenuContainer, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: e.menuIconContainer,
        onClick: c ? n : r,
        children: /* @__PURE__ */ l("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ t(
            "img",
            {
              src: O,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${c ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ t(
            "img",
            {
              src: y,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${c ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ t(
      "a",
      {
        href: s ? `/${s}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: $,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    u ? /* @__PURE__ */ t(
      G,
      {
        isAuthenticated: u,
        userImage: p,
        openAuthModal: g,
        logout: o,
        hasNotifications: m,
        closeMenuModal: n,
        language: s,
        getTranslation: i
      }
    ) : d ? /* @__PURE__ */ l(w, { children: [
      /* @__PURE__ */ t(
        B,
        {
          label: i("pages.get-help"),
          onClick: L,
          className: e.mobileMenuGradientButton
        }
      ),
      /* @__PURE__ */ t(
        I,
        {
          language: s || "en",
          titleLabel: i("pages.get-help"),
          getTranslation: i,
          isLawyerSupported: d,
          onRequestLawyer: f,
          closeMenu: k,
          externalIsOpen: b,
          externalOnOpen: L,
          externalOnClose: k,
          hideDefaultTrigger: !0
        }
      )
    ] }) : /* @__PURE__ */ t(j, { getTranslation: i })
  ] });
}, K = (a) => {
  const {
    handleLogout: c,
    language: n,
    closeMenu: r,
    onAccountClick: g,
    getTranslation: o,
    isLawyerSupported: u,
    onRequestLawyer: m
  } = a, [p, s] = N(!1), i = h(() => {
    s(!0);
  }, []), d = h(() => {
    s(!1);
  }, []), f = A(() => {
    var M;
    const b = (M = S[n]) == null ? void 0 : M.map((L) => ({
      ...L,
      path: `/${n}/${D(L.title)}`
    }));
    return b || null;
  }, [n]);
  return /* @__PURE__ */ l("div", { className: e.menuModalContent, children: [
    /* @__PURE__ */ l("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ l(
        "div",
        {
          className: `${e.mainMenuLink} ${e.gradientText}`,
          onClick: i,
          children: [
            /* @__PURE__ */ t("div", { className: e.gradientTextContent, children: o("pages.get-help") }),
            /* @__PURE__ */ t(F, { className: `${e.arrowIcon}` })
          ]
        }
      ),
      /* @__PURE__ */ t(
        I,
        {
          language: n,
          titleLabel: o("pages.get-help"),
          getTranslation: o,
          isLawyerSupported: u,
          onRequestLawyer: m,
          closeMenu: d,
          externalIsOpen: p,
          externalOnOpen: i,
          externalOnClose: d,
          hideDefaultTrigger: !0
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      f && /* @__PURE__ */ t(
        C,
        {
          language: n,
          titleLabel: o("pages.areas-of-law"),
          link: `/${n}/library`,
          items: f,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      /* @__PURE__ */ t(
        C,
        {
          language: n,
          titleLabel: o("pages.about"),
          link: `/${n}/about`,
          items: H({ language: n, getTranslation: o }),
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      /* @__PURE__ */ t(
        q,
        {
          language: n,
          getTranslation: o,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      a.isAuthenticated ? /* @__PURE__ */ t(
        T,
        {
          language: n,
          handleLogout: c,
          userImage: a.userImage,
          hasNotifications: a.hasNotifications,
          getTranslation: o
        }
      ) : /* @__PURE__ */ l("div", { className: e.mainMenuLink, onClick: g, children: [
        o("pages.account"),
        /* @__PURE__ */ t(x, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: e.menuLinksContainer, children: [
      n.includes("en") && /* @__PURE__ */ t(
        "a",
        {
          href: n ? `/${n}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: r,
          children: o("pages.insights")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: n ? `/${n}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: r,
          children: o("pages.faqs")
        }
      ),
      f && /* @__PURE__ */ t(
        "a",
        {
          href: n ? `/${n}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: r,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: n ? `/${n}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: r,
          children: o("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  ce as MobileMenu
};
